import { KTSVG } from '../../../_metronic/helpers'
import React, { FC, forwardRef, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useAuth } from '../../../app/modules/auth'
import { useDeletePurchase } from '../../contextProviders/Atomqueryprovider'
import dayjs from 'dayjs'

type Props = {
  show: boolean
  handleClose: () => void
  purchasetodelete: any
  deleteselectedpurchase: any
  statedeletingpurchase:any
  cannotDeletepurchase:any
}

const CURRENCY_APP = process.env.REACT_APP_CURRENCY

export const DeletePurchase: FC<Props> = forwardRef((props, ref) => {
  const { currentUser } = useAuth()
  const [error, setError] = useState<string | null>(null)
  const deleteMutation = useDeletePurchase(props.purchasetodelete.purchase_id, Number(currentUser?.user_id))

  useEffect(() => {
    if (deleteMutation.isSuccess) {
      props.handleClose()
    }
    if (deleteMutation.isError) {
      setError('Error deleting purchase. This purchase cannot be deleted due to existing dependencies or transactions.')
    }
  }, [deleteMutation.isSuccess, deleteMutation.isError, props])

  const handleDelete = () => {
    setError(null)
    deleteMutation.mutate()
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Delete Purchase
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{props.purchasetodelete.purchase_number}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row mb-7'>
            <div className='card bg-light'>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='required card-label fw-bolder fs-5 mb-1'>Purchase Description</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    {props.purchasetodelete.supplier_name}
                  </span>
                </h3>
              </div>
              {/* end::Header */}
              {/* begin::Body */}
              <div className='card-body py-3 mb-5'>
                <div className='row'>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Total Amount: </span>
                    {props.purchasetodelete.total_amount} {CURRENCY_APP}
                  </div>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Amount Paid: </span>
                    {props.purchasetodelete.amount_paid} {CURRENCY_APP}
                  </div>
                </div>
                <div className='row mt-2'>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Purchase Date: </span>
                    {dayjs(props.purchasetodelete.purchase_date).format('LL')}
                  </div>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Payment Status: </span>
                    {props.purchasetodelete.payment_status}
                  </div>
                </div>
                {props.purchasetodelete.notes && (
                  <div className='mt-2'>
                    <span className='fw-bold'>Notes: </span>
                    {props.purchasetodelete.notes}
                  </div>
                )}
              </div>
              {/* end::Body */}
            </div>
          </div>

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above purchase?
          </span>

          {error && (
            <div className='alert alert-danger mt-5'>
              <div className='alert-text font-weight-bold'>
                {error}
              </div>
            </div>
          )}
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={handleDelete}
            disabled={deleteMutation.isLoading}
          >
            {!deleteMutation.isLoading && <span className='indicator-label'>Delete Purchase</span>}
            {deleteMutation.isLoading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})